module.exports = __webpack_public_path__ + "static/Oral rehabilitation intraoral before-cd026f9d4020c9c846f89b95c0ea207d.jpg";